import React, { useState } from "react";

import { ToggleButton } from "react-bootstrap";

import OrdersDataGridToolbarComponent from "../../orders/components/OrdersDataGridToolbarComponent";
import { PropsFromReduxSearch } from "../containers/SearchContainer";
// import OrdersDataGrid from '../../orders/components/OrdersDataGridComponent'
// import PropertyDataGrid from '../../../common/components/PropertyDataGridComponent'

const SeachComponent = (_props: PropsFromReduxSearch) => {
  const queryParams = new URLSearchParams(window.location.search);
  const query = queryParams.has("q") ? queryParams.get("q") : "";
  const [showProperty, setShowProperty] = useState(true);

  // Partie Bien
  const [inputFilter, setInputFilter] = useState(query !== null ? query : "");

  // const getFilteredProperties = () => {
  //     let propertiesSelected: Array<PropertyLineDescription> = []
  //     if (inputFilter !== '')
  //         propertiesSelected = myProperties.filter((item) => item.property.address.street.toLowerCase().includes(inputFilter.toLowerCase())
  //             || item.leavingTenant.name.toLowerCase().includes(inputFilter.toLowerCase())
  //             || item.property.address.city.toLowerCase().includes(inputFilter.toLowerCase())
  //             || item.property.address.zip.toLowerCase().includes(inputFilter.toLowerCase())
  //             || item.property.owner.lastname.toLowerCase().includes(inputFilter.toLowerCase()))
  //     else propertiesSelected = myProperties
  //     return propertiesSelected
  // }

  // Partie Commande
  //eslint-disable-next-line
  const [appointmentFilter, setAppointmentFilter] = useState("");
  const [prestationFilter, setPrestationFilter] = useState("Tous");

  // const getOrders = () => {
  //     let ordersSelected: Array<OrderDescription> = []

  //     // ---- filtre par prestation ----
  //     if (prestationFilter !== 'Tous') {
  //         ordersSelected = myOrders.filter((item) => (item.serviceType === prestationFilter))
  //     } else ordersSelected = myOrders

  //     // ---- filtre par rendez-vous ----
  //     if (appointmentFilter !== '')
  //         ordersSelected = ordersSelected.filter((item) => (item.appointmentState === appointmentFilter))

  //     // ---- filtre par input ----
  //     if (inputFilter !== '')
  //         return ordersSelected.filter((item) => item.property.address.street.toLowerCase().includes(inputFilter.toLowerCase())
  //             || item.tenant.lastname.toLowerCase().includes(inputFilter.toLowerCase())
  //             || item.property.address.city.toLowerCase().includes(inputFilter.toLowerCase())
  //             || item.property.address.zip.toLowerCase().includes(inputFilter.toLowerCase())
  //             || item.property.owner.lastname.toLowerCase().includes(inputFilter.toLowerCase()))
  //     else return ordersSelected
  // }

  const resetFilters = () => {
    setAppointmentFilter("");
    setPrestationFilter("Tous");
    setInputFilter("");
  };

  return (
    <div className="mx-3 mt-5">
      <h1 className="mb-2 d-none d-lg-block">Mes recherches</h1>
      <h2 className="mb-2 d-lg-none text-center">Mes recherches</h2>

      {/* Switch button Bien/Commandes */}
      <ToggleButton
        className="mb-3 toogleButton-noChange"
        id="toggle-check"
        type="checkbox"
        variant="primary"
        checked={showProperty}
        value="0"
        onChange={(e) => setShowProperty(e.currentTarget.checked)}
      >
        Résultats sur les {showProperty === true ? "Biens" : "Commandes"}
      </ToggleButton>
      {showProperty === true ? (
        // <PropertyDataGrid rowProps={getFilteredProperties()} states={{ inputFilter, setInputFilter }} />
        <></>
      ) : (
        <>
          <OrdersDataGridToolbarComponent
            states={{
              setAppointmentFilter,
              setPrestationFilter,
              prestationFilter,
              inputFilter,
              setInputFilter,
              resetFilters,
            }}
          />
          {/* <OrdersDataGrid rowProps={getOrders()} selectedOrders={selectedOrders} setSelectedOrders={setSelectedOrders} /> */}
        </>
      )}
    </div>
  );
};
export default SeachComponent;
